import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableVodCatalog from './tableVodTemplateCatalog';

export default {
  title: 'General',
  attributeName: 'ingestServerGeneral',
  fields: [
    {
      attributeName: 'hostName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Host name',
      label: 'Host name',
      required: true,
      helpText: 'Name of the hostname to connect.',
      errorText: '',
    },
    {
      attributeName: 'ip',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'IP',
      label: 'IP of the ingest server',
      required: true,
      helpText: 'Name of the ingest server to connect.',
      errorText: '',
    },
  ],
};
